/**
 * The clock (D9). The only place in the client that reads the wall clock.
 *
 * Everything time-shaped goes through here: the countdown renders
 * `expiry_at_ms − t_server_estimate`, ticking on `performance.now()`; the LRU's
 * TTL and the rAF budget take their `now` from here; and every REST payload and
 * WS frame feeds `observeServerTime` on the way past.
 */

export {
  Clock,
  DEFAULT_EWMA_ALPHA,
  DEFAULT_PONG_MAX_AGE_MS,
  DEFAULT_PONG_WINDOW,
} from './clock'
export type { ClockOptions, ClockStatus, ClockSyncSource, PongTimestamps, SyncResult } from './clock'

export {
  DRIFT_SNAP_THRESHOLD_MS,
  MAX_RTT_MS,
  MAX_SLEW_RATE_MS_PER_S,
  MIN_SAMPLES,
  estimateOffset,
  filterSamples,
  median,
  offsetOf,
  rttOf,
} from './offset'
export type { OffsetEstimate, SampleRejection, TimeSample } from './offset'

export {
  COLD_LOAD_SAMPLES,
  COLD_LOAD_SPREAD_MS,
  ClockSyncScheduler,
  RESYNC_INTERVAL_MS,
  RESYNC_SAMPLES,
  WAKE_RESYNC_THRESHOLD_MS,
  collectSamples,
  syncClock,
} from './handshake'
export type {
  ClockSyncSchedulerOptions,
  HandshakeOptions,
  HandshakeResult,
  SchedulerHost,
  ServerTimeReading,
  TimeFetcher,
} from './handshake'

import { Clock } from './clock'

/**
 * The tab's clock. One instance, like the one socket — two clocks would be two
 * countdowns, and they would disagree in the last second.
 */
let shared: Clock | null = null

export function sharedClock(): Clock {
  shared ??= new Clock()
  return shared
}

/** Tests only. */
export function __resetSharedClock(): void {
  shared = null
}
